import * as BABYLON from 'babylonjs';
import * as ZapparBabylon from '@zappar/zappar-babylonjs';
import { requestCameraPermission } from './cameraPermission';
import 'babylonjs-loaders';
import './index.css';

if (ZapparBabylon.browserIncompatible()) {
  ZapparBabylon.browserIncompatibleUI();
  throw new Error('Unsupported browser');
}

declare global {
  interface Window {
    resetModel: () => void;
    placeModel: () => void;
    destroyModel: () => void;
    loadModel: (modelUrl: any, scale: any, roatate: any, positionY: any, useColor: any) => void;
  }
}

const canvas = document.createElement('canvas');
document.body.appendChild(canvas);
const baseURL = window.location.href;

const engine = new BABYLON.Engine(canvas, true);
const scene = new BABYLON.Scene(engine);

const light = new BABYLON.DirectionalLight('dir02', new BABYLON.Vector3(0, -1, -1), scene);
light.position = new BABYLON.Vector3(0, 5, 5);

const light1 = new BABYLON.HemisphericLight('hemi', new BABYLON.Vector3(1, 1, 0), scene);

const camera = new ZapparBabylon.Camera('zapparCamera', scene);

requestCameraPermission().then(() => {
  console.log('Camera started');
  camera.start();
}).catch((error) => {
  console.error(error.message);
});

const instantTracker = new ZapparBabylon.InstantWorldTracker();
const trackerTransformNode = new ZapparBabylon.InstantWorldAnchorTransformNode('tracker', camera, instantTracker, scene);

let mesh: any;
let animationGroup: BABYLON.AnimationGroup | null = null;

window.loadModel = (modelUrl: any, scale: any, roatate: any = 0, positionY: any = 0, useColor: any = false) => {
  BABYLON.SceneLoader.ImportMesh(null, '', baseURL + modelUrl, scene, (meshes, particleSystems, skeletons, animationGroups) => {
    [mesh] = meshes;

    // Supondo que você queira aplicar essas configurações ao segundo mesh
    const material = (meshes as any)[1].material;
    if (useColor == true) {
      material.albedoColor = new BABYLON.Color3(7, 7, 7);
    }

    if (animationGroups.length > 0) {
      animationGroup = animationGroups[0];
      if (hasPlaced) {
        animationGroup.start(true); // Start the first animation group in loop mode if placed
      } else {
        animationGroup.stop(); // Stop the animation if the model is reset
      }
    }

    mesh.rotationQuaternion = null;
    mesh.position = new BABYLON.Vector3(0, positionY, 0); // Rotate the mesh to face backwards
    mesh.rotation = new BABYLON.Vector3(roatate, Math.PI, 0); // Rotate the mesh to face backwards
    mesh.scaling = new BABYLON.Vector3(scale, scale, scale);

    mesh.parent = trackerTransformNode;
    light.setDirectionToTarget(mesh.absolutePosition);

    console.log('Model loaded:', mesh);
    console.log('Mesh rotation:', mesh.position);
    console.log('Mesh rotation:', mesh.rotation);
    console.log('Mesh scaling:', mesh.scaling);
  }, null, (scene, message, exception) => {
    console.error('Error loading model:', message, exception);
  });
};

window.destroyModel = () => {
  if (mesh) {
    mesh.dispose(); // Dispose the mesh
    mesh = null; // Set the mesh variable to null
    console.log('Model destroyed');
  }
};

let hasPlaced = false;
const placeButton = document.getElementById('placeButton')!;
const resetButton = document.getElementById('resetButton')!;

window.placeModel = () => {
  hasPlaced = true;
  placeButton.style.display = 'none';
  resetButton.style.display = 'block';
  if (animationGroup) {
    animationGroup.start(true); // Start the animation if the model has been placed
  }
};

window.resetModel = () => {
  hasPlaced = false;
  placeButton.style.display = 'block';
  resetButton.style.display = 'none';
  if (animationGroup) {
    animationGroup.stop(); // Stop the animation if the model is reset
  }
  // Reset model position
  if (mesh) {
    mesh.position = new BABYLON.Vector3(0, 0, 0); // Adjust based on initial position requirements
    console.log('Model reset');
  }
};

window.addEventListener('resize', () => {
  engine.resize();
});

engine.runRenderLoop(() => {
  if (scene.isReady()) {
    placeButton.innerHTML = 'Posicione o objeto sobre uma superfície e clique aqui para fixá-lo';
  }
  if (!hasPlaced) {
    instantTracker.setAnchorPoseFromCameraOffset(0, 0, -10);
  }

  camera.updateFrame();
  scene.render();
});